import { StyledSpinner } from '@tryhackme/thm-ui-components';
import { useGetAllCompaniesQuery } from './corporate.slice';
import { CorporateContainer } from './corporate';
export const AdminCorporate = () => {
  const {
    data,
    isLoading
  } = useGetAllCompaniesQuery();
  if (isLoading) {
    return <StyledSpinner color="black" />;
  }
  return <CorporateContainer companiesData={data?.companies ?? []} data-sentry-element="CorporateContainer" data-sentry-component="AdminCorporate" data-sentry-source-file="index.tsx" />;
};